// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"NextButton_iconContainer__n5q4G","tickIconContainer":"NextButton_tickIconContainer__1vF4F","saveIconContainer":"NextButton_saveIconContainer__3ogPY"};